export default __webpack_public_path__ + "static/media/building.b38fdee1.png";